import { configure } from 'mobx';

// Every state change must go through an action, so a write after an `await`
// (which runs outside the original action) is reported instead of silently
// slipping through.
configure({ enforceActions: 'always' });
